import { IMetamaskAdapter } from './BlockchainAdapter.types'
import { prefixedIntToHex } from '../util/dataDecoders'
import { evmNetworksData } from '../util/networksData'
import { chainType, networkType } from '../util/types'
import { evmNetworkIds } from '../util/chainIds'
import { toast } from 'react-toastify'

const ethereum = window.ethereum

const handleConnectMetamask = async () => {
  const response = (await ethereum?.request({
    method: 'eth_requestAccounts',
    params: [],
  })) as string[]
  return response?.[0]
}

const handleSwitchNetwork = async (chainId: number) => {
  const response = await ethereum?.request({
    method: 'wallet_switchEthereumChain',
    params: [{ chainId: prefixedIntToHex(chainId) }],
  })
  return response
}

const handleAddNetwork = async (chain: chainType, network: networkType) => {
  try {
    const response = await ethereum?.request({
      method: 'wallet_addEthereumChain',
      params: [evmNetworksData[chain][network]],
    })
    return response
  } catch (error) {
    console.error('error: ', error)
    toast.error('Could not add network to Metamask')
    throw error
  }
}

const handleSendRequest = async (params: any) => {
  try {
    const response = await ethereum?.request({
      method: 'eth_sendTransaction',
      params: [params],
    })
    return response
  } catch (error) {
    console.error('error: ', error)
    toast.error('Something went wrong. Please try again.')
    throw error
  }
}

class MetamaskAdapter implements IMetamaskAdapter {
  public connector = ethereum

  async connect(): Promise<string> {
    return await handleConnectMetamask()
  }

  async switchNetwork(chain: chainType, network: networkType): Promise<any> {
    try {
      await handleSwitchNetwork(evmNetworkIds[chain][network])
    } catch (error) {
      console.error('error: ', error)
      //@ts-ignore
      if (error.code !== 4001) {
        await handleAddNetwork(chain, network)
      } else {
        throw error
      }
    }
  }

  async sendTransaction(params: any): Promise<any> {
    return await handleSendRequest(params)
  }

  async checkChainMatch(chain: chainType, network: networkType): Promise<boolean> {
    const connectedNetwork = ethereum?.networkVersion
    if (connectedNetwork === evmNetworkIds[chain][network].toString()) {
      return true
    } else {
      try {
        await this.switchNetwork(chain, network)
        return true
      } catch (error) {
        console.error('error: ', error)
        return false
      }
    }
  }
}

export default MetamaskAdapter
